/* @noflow FIXME */
import * as React from 'react';
import OrganizationClassesTable from 'organizations/components/OrganizationClassesTable';
import { initializeTable, loadOrganizationClasses } from 'reducers/organizationClassesTables';
import type { OrganizationClassesFetchOptions } from 'clients/api/organizationClasses';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const PER_PAGE = 20;

type Props = {
  query: string,
  sort: string,
  organizationId: number,

  /* redux props */
  initializeTable: (organizationId: number) => any,
  loadOrganizationClasses: (
    organizationId: number,
    options: OrganizationClassesFetchOptions
  ) => any,
  initialized: boolean,
  allLoaded?: boolean,
  groups?: Group[],
  page?: number,
};

class OrganizationClassesTableContainer extends React.Component<Props> {
  componentWillMount() {
    if (!this.props.initialized) {
      this.props.initializeTable(this.props.organizationId);
    }
  }

  componentWillUpdate(nextProps: Props) {
    const initialized = !this.props.initialized && nextProps.initialized;
    const newQuery = this.props.query !== nextProps.query;
    const newSort = this.props.sort !== nextProps.sort;

    if (initialized || newSort || newQuery) {
      this.loadPage(1, nextProps);
    }
  }

  loadPage(page: number, nextProps?: Props) {
    const props = nextProps || this.props;

    let sortOptions = {};

    if (props.sort) {
      switch (props.sort) {
        case 'name_asc':
          sortOptions = { sort: 'name', direction: 'asc' };
          break;
        case 'name_desc':
          sortOptions = { sort: 'name', direction: 'desc' };
          break;
        case 'created_at_asc':
          sortOptions = { sort: 'created', direction: 'asc' };
          break;
        case 'created_at_desc':
          sortOptions = { sort: 'created', direction: 'desc' };
          break;
        default:
      }
    }

    this.props.loadOrganizationClasses(this.props.organizationId, {
      sortDirection: sortOptions.direction,
      sort: sortOptions.sort,
      query: props.query,
      perPage: PER_PAGE,
      page,
    });
  }

  loadNextPage = () => this.loadPage(this.props.page + 1);

  render() {
    if (!this.props.initialized) {
      return <tbody />;
    }

    return (
      <OrganizationClassesTable
        groups={this.props.groups}
        allLoaded={this.props.allLoaded}
        loadNextPage={this.loadNextPage}
      />
    );
  }
}

function mapStateToProps(state: any, props: Props) {
  const table = state.organizationClassesTables.get(props.organizationId);

  if (!table) {
    return { initialized: false };
  }

  return {
    initialized: true,
    page: table.page,
    groups: table.groups,
    loading: table.loading,
    allLoaded: table.allLoaded,
  };
}

function mapDispatchToProps(dispatch: Function) {
  // $FlowFixMe
  return bindActionCreators({ initializeTable, loadOrganizationClasses }, dispatch);
}

export { OrganizationClassesTableContainer };
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationClassesTableContainer);
